<template>
  <div>
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div class="intro-y col-span-12 box mt-5">
        <div
          class="flex flex-col sm:flex-row items-center p-5 border-b dark:border-dark-5 border-gray-200"
        >
          <h2 class="font-medium text-base mr-auto">
            사용자관리
          </h2>
          <div
            class="w-full sm:w-auto flex items-center sm:ml-auto mt-3 sm:mt-0 hidden"
          >
            <button
              class="button text-white bg-theme-1 shadow-md mr-2"
              @click="clickAddBtn"
            >
              사용자등록
            </button>
          </div>
        </div>
        <!-- BEGIN: Data List -->
        <div
          class="intro-y col-span-12 overflow-auto lg:overflow-visible py-5 px-10"
        >
          <table class="table -mt-2">
            <thead>
              <tr class="text-gray-700">
                <th class="border-b-2 dark:border-dark-5 whitespace-no-wrap">
                  <div class="font-medium whitespace-no-wrap">
                    번호
                  </div>
                </th>
                <th class="border-b-2 dark:border-dark-5 whitespace-no-wrap">
                  <div class="font-medium whitespace-no-wrap">
                    이름
                  </div>
                </th>
                <th class="border-b-2 dark:border-dark-5 whitespace-no-wrap">
                  <div class="font-medium whitespace-no-wrap">
                    이메일
                  </div>
                </th>
                <th class="border-b-2 dark:border-dark-5 whitespace-no-wrap">
                  <div class="font-medium whitespace-no-wrap">
                    지점
                  </div>
                </th>
                <th class="border-b-2 dark:border-dark-5 whitespace-no-wrap">
                  <div class="font-medium whitespace-no-wrap">
                    관리자
                  </div>
                </th>
                <th class="border-b-2 dark:border-dark-5 whitespace-no-wrap">
                  <div class="font-medium whitespace-no-wrap">
                    권한
                  </div>
                </th>
                <th
                  class="border-b-2 dark:border-dark-5 text-center whitespace-no-wrap"
                >
                  <div class="font-medium whitespace-no-wrap">
                    편집
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(admin, index) in admins"
                :key="index"
                class="intro-x border-b-2 dark:border-dark-5"
              >
                <td>
                  <div class="font-medium whitespace-no-wrap py-1">
                    {{ index + 1 }}
                  </div>
                </td>
                <td>
                  <div class="font-medium whitespace-no-wrap">
                    {{ admin.username }}
                  </div>
                </td>
                <td>
                  <div class="font-medium whitespace-no-wrap">
                    {{ admin.email }}
                  </div>
                </td>
                <td>
                  <div class="font-medium whitespace-no-wrap">
                    {{ $h.isset(admin.agency) ? admin.agency.name : "" }}
                  </div>
                </td>
                <td>
                  <el-switch
                    v-model="admin.isAdminFlag"
                    active-color="rgb(0, 172, 172)"
                    inactive-color="rgb(57, 57, 57)"
                    @change="saveUserInfo(admin)"
                  ></el-switch>
                </td>
                <td>
                  <el-switch
                    v-model="admin.isAllowFlag"
                    active-color="rgb(0, 172, 172)"
                    inactive-color="rgb(57, 57, 57)"
                    @change="saveUserInfo(admin)"
                  ></el-switch>
                </td>
                <td class="table-report__action w-56">
                  <div class="flex justify-center items-center">
                    <a
                      class="flex items-center text-theme-6"
                      href="javascript:;"
                      @click="clickDeleteBtn(admin.id)"
                    >
                      <Trash2Icon class="w-4 h-4 mr-1" /> 삭제
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- END: Data List -->
      </div>
      <!-- BEGIN: Delete Confirmation Modal -->
      <div id="delete-confirmation-modal" class="modal">
        <div class="modal__content">
          <div class="p-5 text-center">
            <xCircleIcon class="w-16 h-16 text-theme-6 mx-auto mt-3" />
            <div class="text-3xl mt-5 mb-5">삭제 하시겠습니까?</div>
          </div>
          <div class="px-5 pb-8 text-center">
            <button
              type="button"
              data-dismiss="modal"
              class="button w-24 border text-gray-700 mr-1"
            >
              취소
            </button>
            <button
              type="button"
              data-dismiss="modal"
              class="button w-24 bg-theme-6 text-white"
              @click="handleDelete"
            >
              삭제
            </button>
          </div>
        </div>
      </div>
      <!-- END: Delete Confirmation Modal -->
      <div id="header-footer-modal-preview" class="modal">
        <div class="modal__content">
          <div
            class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200 dark:border-dark-5 relative"
          >
            <h2 class="font-medium text-base mr-auto">지점등록</h2>
            <a
              data-dismiss="modal"
              href="javascript:;"
              class="absolute right-0 top-0 mt-3 mr-3"
            >
              <xIcon class="w-8 h-8 text-gray-500" />
            </a>
          </div>
          <div class="px-10 py-5 grid grid-cols-12 row-gap-2">
            <div class="col-span-12">
              <div class="flex flex-col sm:flex-row items-center">
                <label class="w-full sm:w-20 sm:text-left sm:mr-5">
                  이름
                </label>
                <input
                  v-model="register.name"
                  type="email"
                  placeholder="이름을 입력하세요"
                  autocomplete="off"
                  class="input w-full border mt-2 flex-1"
                />
              </div>
            </div>
          </div>
          <div
            class="px-5 py-3 text-right border-t border-gray-200 dark:border-dark-5"
          >
            <button
              type="button"
              data-dismiss="modal"
              class="button w-20 border text-gray-700 dark:border-dark-5 dark:text-gray-300 mr-1"
            >
              취소
            </button>
            <button
              type="button"
              data-dismiss="modal"
              class="button w-20 bg-theme-1 text-white"
              @click="handleRegister"
            >
              등록
            </button>
          </div>
        </div>
      </div>
      <div id="edit-modal-preview" class="modal">
        <div class="modal__content">
          <div
            class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200 dark:border-dark-5 relative"
          >
            <h2 class="font-medium text-base mr-auto">지점수정</h2>
            <a
              data-dismiss="modal"
              href="javascript:;"
              class="absolute right-0 top-0 mt-3 mr-3"
            >
              <xIcon class="w-8 h-8 text-gray-500" />
            </a>
          </div>
          <div class="px-10 py-5 grid grid-cols-12 row-gap-2">
            <div class="col-span-12">
              <div class="flex flex-col sm:flex-row items-center">
                <label class="w-full sm:w-20 sm:text-left sm:mr-5">
                  이름
                </label>
                <input
                  v-model="register.name"
                  type="email"
                  placeholder="이름을 입력하세요"
                  autocomplete="off"
                  class="input w-full border mt-2 flex-1"
                />
              </div>
            </div>
          </div>
          <div
            class="px-5 py-3 text-right border-t border-gray-200 dark:border-dark-5"
          >
            <button
              type="button"
              data-dismiss="modal"
              class="button w-20 border text-gray-700 dark:border-dark-5 dark:text-gray-300 mr-1"
            >
              취소
            </button>
            <button
              type="button"
              data-dismiss="modal"
              class="button w-20 bg-theme-1 text-white"
              @click="handleUpdate"
            >
              수정
            </button>
            <button
              type="button"
              data-dismiss="modal"
              class="button w-20 bg-theme-1 text-white"
              @click="handleUpdate"
            >
              수정
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      admins: [],
      register: {
        id: "",
        name: "",
        hundredAmount: 0,
        fiveHundredAmount: 0,
        bankAmount: 0
      }
    };
  },
  async mounted() {
    await this.tokenLogin();
    if (
      this.$store.state.auth.user != null &&
      this.$store.state.auth.user.isAdmin == 0
    ) {
      this.$router.replace("/main/transaction");
    }
    this.getAdmins();
  },
  methods: {
    async tokenLogin() {
      let data = {
        token: window.localStorage.getItem("exchange_token")
      };
      let resultData = {};
      await axios.post(this.$api().tokenLogin, data).then(res => {
        resultData = res.data;
      });
      if (this.$h.isEmpty(resultData)) {
        this.$store.commit("auth/SET_USER", null);
        this.$store.commit("auth/SET_ISLOGINED", false);
        this.$router.replace("/");
      } else if (resultData.error) {
        this.$store.commit("auth/SET_USER", null);
        this.$store.commit("auth/SET_ISLOGINED", false);
        this.$router.replace("/");
      } else {
        this.$store.commit("auth/SET_USER", resultData.userData);
        this.$store.commit("auth/SET_ISLOGINED", true);
        window.localStorage.setItem(
          "exchange_token",
          resultData.userData.token
        );
      }
    },
    async getAdmins() {
      let data = {
        token: this.$h.assign(this.$store.state.auth.user.token),
        agencyId: this.$store.state.auth.user.agencyId,
        isAdmin: this.$store.state.auth.user.isAdmin
      };
      await axios.post(this.$api().getAdmins, data).then(res => {
        let resultData = this.$h.assign(res.data);
        this.admins = resultData.data;
      });
    },
    clickAddBtn() {
      this.register.id = "";
      this.register.name = "";
      this.register.hundredAmount = 0;
      this.register.fiveHundredAmount = 0;
      this.register.bankAmount = 0;
      cash("#header-footer-modal-preview").modal("show");
      // console.log("admin page add btn clicked");
    },
    clickDeleteBtn(id) {
      this.register.id = id;
      cash("#delete-confirmation-modal").modal("show");
    },
    async handleRegister() {
      let data = {
        name: this.register.name,
        code: this.register.code,
        token: this.$h.assign(this.$store.state.auth.user.token)
      };
      await axios.post(this.$api().addAgency, data).then(res => {
        if (res.status == 200) {
          this.getAdmins();
        }
      });
    },
    async handleDelete() {
      let data = {
        id: this.register.id,
        token: this.$h.assign(this.$store.state.auth.user.token)
      };
      await axios.post(this.$api().deleteAdmin, data).then(res => {
        if (res.status == 200) {
          this.getAdmins();
        }
      });
    },
    async handleUpdate() {
      let data = {
        id: this.register.id,
        name: this.register.name,
        code: this.register.code,
        token: this.$h.assign(this.$store.state.auth.user.token)
      };
      await axios.post(this.$api().editAgency, data).then(res => {
        if (res.status == 200) {
          this.getAdmins();
        }
      });
    },
    async saveUserInfo(admin) {
      if (admin.isAdminFlag == true) {
        admin.isAdmin = 1;
      } else {
        admin.isAdmin = 0;
      }
      if (admin.isAllowFlag == true) {
        admin.isAllow = 1;
      } else {
        admin.isAllow = 0;
      }
      let data = {
        id: admin.id,
        isAdmin: admin.isAdmin,
        isAllow: admin.isAllow,
        token: this.$h.assign(this.$store.state.auth.user.token)
      };
      await axios.post(this.$api().editAdmin, data).then(res => {
        if (res.status == 200) {
          this.getAdmins();
        }
      });
    }
  }
};
</script>
